var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppoitment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1260)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_104_1260)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0H4.66667V1.33333H11.3333V0H12V1.33333H16V16H0V1.33333H4V0ZM11.3333 2V3.33333H12V2H15.3333V6H0.666667V2H4V3.33333H4.66667V2H11.3333ZM0.666667 6.66667V15.3333H15.3333V6.66667H0.666667Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_104_1260",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0H4.66667V1.33333H11.3333V0H12V1.33333H16V16H0V1.33333H4V0ZM11.3333 2V3.33333H12V2H15.3333V6H0.666667V2H4V3.33333H4.66667V2H11.3333ZM0.666667 6.66667V15.3333H15.3333V6.66667H0.666667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_104_1260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_104_1260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppoitment);
export default __webpack_public_path__ + "static/media/appoitment.109a5802fb33938f9c1d29289579ca03.svg";
export { ForwardRef as ReactComponent };